import BrazilianHighlightsContent from "components/company/v3/brazilian/contents/highlights/BrazilianHighlightsContent";
import {
  CompanyContainer,
  CompanyContentContainer,
  CompanyTabsContent,
  CompanyTabsList,
} from "components/company/v3/CompanyContainers";
import VideosContent from "components/company/v3/contents/highlights/VideosContent";
import useBrazilianIssuer from "components/company/v3/context/hooks/useBrazilianIssuer";
import { CompanyHighlightsTabEnum } from "components/company/v3/menu/enums";
import { Tabs } from "components/ui/Tabs";
import useSelfie from "lib/hooks/useSelfie";
import notUndefinedOrNull from "lib/utils/notUndefinedOrNull";
import { ListChecksIcon, YoutubeIcon } from "lucide-react";
import { useIntl } from "react-intl";

interface BrazilianHighlightsBoxProps {
  tab: CompanyHighlightsTabEnum;
  onChangeTab: (tab: CompanyHighlightsTabEnum) => void;
}

export default function BrazilianHighlightsBox({ tab, onChangeTab }: BrazilianHighlightsBoxProps) {
  const intl = useIntl();
  const viewer = useSelfie();
  const { youtubeVideos } = useBrazilianIssuer();

  return (
    <CompanyContainer className="xl:h-full">
      <CompanyContentContainer>
        <Tabs
          defaultValue={viewer?.isPremium ? CompanyHighlightsTabEnum.HIGHLIGHTS : CompanyHighlightsTabEnum.VIDEOS}
          value={tab}
          onValueChange={(value) => onChangeTab(value as CompanyHighlightsTabEnum)}
          className="h-full w-full"
        >
          <CompanyTabsList
            tabs={[
              viewer?.isPremium
                ? {
                    value: CompanyHighlightsTabEnum.HIGHLIGHTS,
                    label: intl.formatMessage({
                      defaultMessage: "Destaques Trimestrais",
                      description: "Aba do menu superior da empresa",
                      id: "od7EqT",
                    }),
                    icon: <ListChecksIcon className="inline-flex" size={16} strokeWidth={2} />,
                  }
                : null,
              {
                value: CompanyHighlightsTabEnum.VIDEOS,
                label: intl.formatMessage({
                  defaultMessage: "Vídeo",
                  description: "Aba do menu superior da empresa",
                  id: 'vjkGXg',
                }),
                icon: <YoutubeIcon className="inline-flex" size={16} strokeWidth={2} />,
              },
            ].filter(notUndefinedOrNull)}
          />

          {viewer?.isPremium && (
            <CompanyTabsContent value={CompanyHighlightsTabEnum.HIGHLIGHTS}>
              <BrazilianHighlightsContent />
            </CompanyTabsContent>
          )}

          <CompanyTabsContent value={CompanyHighlightsTabEnum.VIDEOS}>
            <VideosContent youtubeVideos={youtubeVideos} />
          </CompanyTabsContent>
        </Tabs>
      </CompanyContentContainer>
    </CompanyContainer>
  );
}
